import { Box, Button, Grid, Spacer, Tag, Text } from '@flexisaf/flexibull2';
import { useSelector } from 'react-redux';
import { selectCurrentSubscription } from 'redux/configuration/selector';

import UpgradeIMG from 'assets/upgrade.svg';
import { Theme } from 'config/theme';
import useSubscriptionDetail from 'general-hooks/useSubscriptionDetail';
import { lighten } from 'polished';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { select_school_admin, select_super_admin } from 'redux/privileges/selectors';
import styled from 'styled-components';
import { subscriptionFeatures } from 'utils/utils';

type IProps = {
  featureName: string;
  featureDescription?: string;
};

const PlanIndicator = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${(props) =>
    props.color ? lighten(0.3, props.color) : lighten(0.3, props.theme.PrimaryMint)};
  position: relative;
  border-radius: 100px;
  overflow: visible;

  & .miniBubble {
    width: 12px;
    height: 12px;
    background-color: ${(props) =>
      props.color ? lighten(0.4, props.color) : lighten(0.4, props.theme.PrimaryMint)};
    position: absolute;
    top: 14px;
    right: -4px;
    border-radius: 100px;
  }
`;

export const HigherPlanRequired = ({ featureName, featureDescription }: IProps) => {
  const history = useNavigate();
  const currentSubscription = useSelector(selectCurrentSubscription);
  const superAdmin = useSelector(select_super_admin);
  const schoolAdmin = useSelector(select_school_admin);

  return (
    <Box margin="20px" pad="20px" align="center" borderRadius="5px">
      <Box display="flex">
        <img src={UpgradeIMG} style={{ margin: 'auto' }} />
      </Box>
      <Spacer space={15} />
      <Tag solid color="#EEDEFE" style={{ borderRadius: Theme.PrimaryRadius }}>
        <Text
          uppercase
          size={Theme.Small}
          color={Theme.SecondaryColor}
          style={{ fontWeight: '800', letterSpacing: '2px' }}
        >
          Upgrade REQUIRED
        </Text>
      </Tag>
      <Box margin="auto" width="600px">
        <Spacer space={15} />
        <Text block size={Theme.H5} pad="20px 0" style={{ fontWeight: '600' }}>
          <span className="saf-crown-1" /> Upgrade to have access
        </Text>
        <Spacer space={15} />
        <Text size={Theme.H6} pad="20px 0" style={{ lineHeight: '25px' }}>
          {' '}
          Sorry, your subscription does not cover this feature. Contact your administrator for
          upgrade to higher plan to unlock <b>{featureName}</b>.
          {/* You are currently on the <b>{currentSubscription?.subscription_plan?.name}</b>, Please
          upgrade your plan to unlock <b>{featureName}</b>. */}
        </Text>{' '}
        <br />
        <br />
        <Box
          pad="30px"
          background={Theme.PrimaryBackground}
          style={{
            border: `1px solid ${Theme.PrimaryFontColor}`,
            borderRadius: Theme.SecondaryRadius,
          }}
        >
          <Text block color="#707070" size={Theme.H6} style={{ fontWeight: '600' }}>
            Description
          </Text>
          <Text size="16px" color="#707070">
            {' '}
            <Text bold size={Theme.H5}>
              "
            </Text>
            {featureDescription}
            <Text bold size={Theme.H5}>
              "
            </Text>
          </Text>
        </Box>
        <Spacer space={20} />
        <Box
          background={Theme.PrimaryWhite}
          margin="auto"
          round="high"
          width="100%"
          align="left"
          style={{
            border: `1px solid ${Theme.PrimaryBorderColor}`,
            zIndex: 10,
            maxWidth: '500px',
          }}
        >
          <Box pad="15px 20px 15px">
            <Grid default="max-content auto max-content" alignItems="center">
              <PlanIndicator color={Theme.PrimaryRed}>
                <div className="miniBubble"></div>
              </PlanIndicator>
              <Text size={Theme.H6} style={{ fontWeight: '600' }}>
                {' '}
                {currentSubscription?.subscription_plan?.id} Plan
              </Text>
              <Tag
                solid
                color={Theme.PrimaryBorderColor}
                style={{ borderRadius: Theme.PrimaryRadius }}
              >
                <Text color={Theme.PrimaryFontColor}>Current Plan</Text>
              </Tag>
            </Grid>
          </Box>
        </Box>
        <Spacer space={40} />
        <Box pad="10px 0">
          {' '}
          {schoolAdmin || superAdmin ? (
            <Button onClick={() => history('/select-plan')}>Upgrade Now</Button>
          ) : (
            <Text size="16px">Please contact School Admin to enable this feature.</Text>
          )}
          {/* <Button
              pale
              color="#0066F5"
              iconRight={<span className="saf-send-sqaure-2" style={{ fontSize: Theme.H5 }} />}
              onClick={() => {
                history('/select-plan');
              }}
            >
              {' '}
              <Text size={Theme.Paragraph}>View plans</Text>{' '}
            </Button> */}
        </Box>
      </Box>
    </Box>
  );
};

export const SubscriptionCheckWrapper = (props) => {
  const { children, code } = props;
  const { checkSubscriptionPermission } = useSubscriptionDetail();
  const access = checkSubscriptionPermission(code);
  if (access === undefined) {
    return null;
  }
  if (access) {
    return children;
  } else {
    return (
      <HigherPlanRequired
        featureName={subscriptionFeatures[code]?.name}
        featureDescription={subscriptionFeatures[code]?.description}
      />
    );
  }
};

const isOpenRoute = [
  '/select-plan',
  '/plans',
  '/subscription',
  '/user-profile',
  '/expired-plan',
  '/configurations',
  '/sessions-and-terms',
];

export const SubscriptionCheckRedirection = () => {
  const history = useNavigate();
  const currentPathname = window?.location?.pathname;

  const { currentSubscription, subscriptionDetail, isSubscriptionUser } = useSubscriptionDetail();

  useEffect(() => {
    if (isSubscriptionUser && currentSubscription?.id) {
      if (subscriptionDetail?.isSubscriptionActive) {
      } else {
        if (!isOpenRoute.includes(currentPathname)) {
          history('/expired-plan');
        }
      }
    }
  }, [
    currentPathname,
    currentSubscription?.id,
    history,
    isSubscriptionUser,
    subscriptionDetail?.isSubscriptionActive,
  ]);
  return <></>;
};
